export enum UserRole {
  ADMIN = 'admin',
  MEMBER = 'member',
}

export enum NotificationStatus {
  SUCCESS = 'SUCCESS',
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  CUSTOM = 'CUSTOM',
}

export enum SortDirection {
  DESC = 'DESC',
  ASC = 'ASC',
}

export enum Sex {
  MALE = 'male',
  FEMALE = 'female',
}

export enum Placement {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
  BOTTOM = 'bottom',
}

export enum Modals {
  EDIT_FORMULA_ACTIVITY = 'editFormulaActivity',
  DELETE_FORMULA_ACTIVITY = 'deleteFormulaActivity',
}
